<input type="text" [value]="displayValue" (input)="onInputChange($event.target.value)"
    class="form-control">